export default "__VITE_ASSET__z0_XVEUt__"